import React from 'react';
import styled from 'styled-components';

function InfoTooltip({ content }) {
  return (
    <TooltipContainer>
      <sup>
        <InfoIcon
          tabIndex="0"
          role="button"
          aria-label="More information about engagement score calculation">
          <svg
            width="16"
            height="16"
            viewBox="0 0 416.979 416.979"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="var(--blue)"
              d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"
            />
          </svg>
        </InfoIcon>
      </sup>
      <TooltipContent>{content}</TooltipContent>
    </TooltipContainer>
  );
}

const TooltipContainer = styled.div`
  bottom: 2px;
  display: inline-block;
  margin-left: 0.25rem;
  position: relative;
`;

const InfoIcon = styled.span`
  align-items: center;
  cursor: help;
  display: inline-flex;
  justify-content: center;
  transition: color 0.2s ease;

  &:hover,
  &:focus {
    outline: none;

    svg path {
      fill: var(--dark-blue);
    }
  }

  &:focus {
    border-radius: 2px;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.3);
  }

  svg {
    display: block;
  }
`;

const TooltipContent = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 6px;
  bottom: 125%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  color: white;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  left: 50%;
  line-height: 1.4;
  max-width: 280px;
  min-width: 240px;
  opacity: 0;
  padding: 0.75rem;
  pointer-events: none;
  position: absolute;
  text-align: left;
  transform: translateX(-50%);
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
  visibility: hidden;
  white-space: pre-line;
  z-index: 1000;

  /* Tooltip arrow */
  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.9) transparent transparent transparent;
  }

  /* Show tooltip on hover and focus */
  ${TooltipContainer}:hover &,
  ${TooltipContainer} sup ${InfoIcon}:focus + & {
    opacity: 1;
    visibility: visible;
  }

  /* Responsive positioning for smaller screens */
  @media (max-width: 480px) {
    left: 0;
    transform: none;
    max-width: 250px;
    min-width: 200px;

    &::after {
      left: 20px;
      margin-left: 0;
    }
  }

  /* Fallback positioning if tooltip would go off-screen */
  @media (max-height: 600px) {
    top: 125%;
    bottom: auto;

    &::after {
      top: -5px;
      border-color: transparent transparent rgba(0, 0, 0, 0.9) transparent;
    }
  }
`;

export default InfoTooltip;
